// Only `true` shows the enrollment landing; absent, `false` and other values hide it.
export const showsEnrollmentLanding = (doc: {
  showEnrollmentLanding?: unknown;
}): boolean => doc.showEnrollmentLanding === true;
